import React, { useState , useContext, useEffect} from 'react';
import Table from 'react-bootstrap/Table';
import { Button,Row , Col, Form } from 'react-bootstrap';
import dataForm from '../../components/maintenance/data_form.json';

import * as Icon from 'react-bootstrap-icons';
import {AdminContext} from './AdminContext';
import ServiceDetail from './ServiceDetail';
function ServicesList() {

    const {findMaintenance, getMaintenance} = useContext(AdminContext);
    const [maintenanceList, setMaintenanceList] = useState([]);
    const [maintenanceListData, setMaintenanceListData] = useState([]);
    const [maintenanceDetail, setMaintenanceDetail] = useState({});
    const [filtersForm, setFiltersForm] = useState({from_date:'', to_date:'',service:''});
    const [smShow, setSmShow] = useState(false);
    const [filter, setFilter] = useState(false);
    const data_form = dataForm.data;

    const serviceDetail = (id) => {
        setMaintenanceDetail(maintenanceListData.find(function(m){ return id === m.id;}));
        console.log(maintenanceDetail);
        setSmShow(true);
    };


    useEffect( () => {
        findMaintenance(filtersForm).then( (docsSnap) =>{
            if(docsSnap.docs.length > 0){
                let a = docsSnap.docs.map((e)=>{
                    let m = e.data();
                    let date = new Intl.DateTimeFormat('en-ES',
                            {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit'
                            }
                        ).format(m.date);
                    setMaintenanceListData({...maintenanceListData.push( { id: e.id, ...e.data(), date:date})});

                    return <tr>
                        <td>{date}</td>
                        <td>{m.type}</td>
                        <td>{m.patente}</td>
                        <td>{m.description}</td>
                        <td> <Button variant='light' onClick={ () => {serviceDetail(e.id)} } size='sm' type='button'>Ver</Button> </td>
                    </tr>;
                });
                setMaintenanceList(a);

            }else{
            }
        }).catch((e)=>{
            console.log(e);
        })


    },[filter]);


    return (
    <>

        {smShow && <ServiceDetail props={{smShow:smShow ,m:maintenanceDetail,setSmShow:setSmShow }} />}
        <h4 className='pt-2 title'>Servicios</h4>
        <hr />
        <Row className=''>
            <Col md={3} sm={12}>
                <Form.Label>Fecha desde</Form.Label>
                <Form.Control
                    type="date"
                    placeholder="25-03-2024"
                    onChange={ (e) => setFiltersForm({...filtersForm,from_date:e.currentTarget.value}) }
                    required
                    />
            </Col>
            <Col md={3} sm={12}>
                <Form.Label>Fecha hasta</Form.Label>
                <Form.Control
                    type="date"
                    placeholder="25-03-2024"
                    onChange={ (e) => setFiltersForm({...filtersForm,to_date:e.currentTarget.value}) }
                    required
                    />
            </Col>
            <Col md={3} sm={12}>
                <Form.Label>Tipo</Form.Label>
                <Form.Select
                    aria-label="Seleccione"
                    required
                    onChange={ (e) => setFiltersForm({...filtersForm,service:e.currentTarget.value}) }
                    >
                    <option  key={100} value=''>Todos</option>
                    {
                        data_form.map((m) => (
                            <option key={m.option_value} value={m.option_value}>{m.type}</option>
                        ))
                    }
                </Form.Select>
            </Col>
            <Col md={2} sm={12}>
                <br/>
                <Button variant='danger' onClick={ () => setFilter(true) } className='mt-2'   type='button'>Buscar <Icon.Search></Icon.Search></Button>
            </Col>

        </Row>
        <hr />
        <div className='float-right'><h6 >(*) Últimos 20 servicios registrados </h6></div>
        <Table responsive  striped="true" hover="true">
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Patente</th>
                    <th>Descripción</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {maintenanceList}
            </tbody>
        </Table>


    </>


  );
}

export default ServicesList;